import { isDefined } from "@redotech/util/type";
import { PricingRuleSet } from "../../coverage-types";

export function determineRuleSet(
  pricingRuleSets: PricingRuleSet[],
  country: string | null,
) {
  for (const priceSet of pricingRuleSets) {
    if (
      // Blank/whitespace country = no country data (e.g. ingested orders that
      // save "" instead of undefined); treat it as the null sentinel.
      !isDefined(country) ||
      country.trim() === "" ||
      priceSet.countries.some(
        (c) => c.toLowerCase() === country.toLowerCase(),
      ) ||
      priceSet.countries.length == 0
    ) {
      return priceSet;
    }
  }
  return null;
}
